import initializeBannerCarousel from "../experience/heroBannerCarousel";
import gtm from "../gtm";

export function initializePLP() {
    initializeBannerCarousel();

    const $productGrid = $(".product-grid-products");

    gtm.trackApplianceViewItemList($(".js-appliance-product-tile"));

    $productGrid.off("click.applianceGtm")
        .on("click.applianceGtm", ".js-appliance-product-tile a", function (event) {
            const $link        = $(this);
            const $product     = $link.closest(".js-appliance-product-tile");
            const href         = this.href;
            const isPlainClick = event.which === 1
                && !event.ctrlKey
                && !event.metaKey
                && !event.shiftKey
                && !event.altKey
                && $link.attr("target") !== "_blank";

            if (!href || !isPlainClick) {
                gtm.trackApplianceSelectItem($product);
                return;
            }

            event.preventDefault();
            gtm.trackApplianceSelectItem($product, function () {
                window.location.href = href;
            });
        });

    if ($productGrid.length && !$productGrid.data("appliance-gtm-observer")) {
        var trackingTimeout;
        var observer = new MutationObserver(function (mutations) {
            var hasProductChanges = mutations.some(function (mutation) {
                return $(mutation.addedNodes).find(".js-appliance-product-tile").addBack(
                    ".js-appliance-product-tile"
                ).length > 0;
            });

            if (!hasProductChanges) {
                return;
            }

            clearTimeout(trackingTimeout);
            trackingTimeout = setTimeout(function () {
                gtm.trackApplianceViewItemList($(".js-appliance-product-tile"));
            }, 100);
        });

        observer.observe($productGrid[0], {
            childList: true,
            subtree: true
        });
        $productGrid.data("appliance-gtm-observer", observer);
    }
}
